var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90843 3.72106C10.3566 1.42371 13.6435 1.42371 14.0917 3.72106C14.3644 5.11902 15.9054 5.86111 17.1684 5.20272C19.244 4.12076 21.2933 6.69055 19.7766 8.47333C18.8537 9.55817 19.2343 11.2256 20.5365 11.8026C22.6765 12.7508 21.9451 15.9552 19.6056 15.881C18.182 15.8358 17.1157 17.173 17.4765 18.5508C18.0695 20.8151 15.1081 22.2413 13.7075 20.3659C12.8552 19.2247 11.1449 19.2247 10.2926 20.3659C8.89204 22.2413 5.93065 20.8151 6.52363 18.5508C6.88447 17.173 5.81808 15.8358 4.39448 15.881C2.055 15.9552 1.3236 12.7508 3.46362 11.8026C4.76585 11.2256 5.14643 9.55817 4.2235 8.47333C2.70681 6.69055 4.75615 4.12076 6.83172 5.20272C8.09474 5.86111 9.63571 5.11902 9.90843 3.72106Z",
    stroke: "#393556",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 11.9996C15.0001 13.6565 13.6569 14.9996 12.0001 14.9996C10.3432 14.9996 9.00007 13.6565 9.00007 11.9996C9.00007 10.3428 10.3432 8.99963 12.0001 8.99963C13.6569 8.99963 15.0001 10.3428 15.0001 11.9996Z",
    stroke: "#393556",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.569296c6.svg";
export { ForwardRef as ReactComponent };